import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "mx-5 mb-5" }

import SimpleForm from "@/components/SimpleForm.vue";
import { ref } from "vue";
import { ReportRequestTypes } from "@/core/types/ReportRequestTypes";
import TenantGlobalService from "@/projects/tenant/services/TenantGlobalService";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import { getTradeRebateStatusSelections } from "@/core/types/RebateStatus";


export default /*#__PURE__*/_defineComponent({
  __name: 'NewReportRequestModal',
  emits: ["fetchData"],
  setup(__props, { expose: __expose, emit: emits }) {

const modalRef = ref();
const isLoading = ref(false);
const period = ref([] as any);
const stateId = ref(null);
const criteria = ref<any>({});

const formData = ref({
  name: "",
  type: ReportRequestTypes.Rebate,
  query: criteria.value,
});

const convertToISO = (prd) => {
  const val = prd.map((x) => (x = x.replace(" ", "T") + "Z"));
  return { from: val ? val[0] : null, to: val ? val[1] : null };
};

const submitRebateReportRequest = async () => {
  isLoading.value = true;
  criteria.value = convertToISO(period.value);
  criteria.value.stateId = stateId.value;
  formData.value.query = criteria.value;
  try {
    await TenantGlobalService.createReportRequest(formData.value);
    MsgPrompt.success("New report request sent successfully").then(() => {
      modalRef.value?.hide();
      emits("fetchData");
    });
  } catch (error) {
    MsgPrompt.error(error);
  } finally {
    isLoading.value = false;
  }
};

__expose({
  show: () => {
    modalRef.value?.show();
  },
  hide: () => {
    modalRef.value?.hide();
  },
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalRef",
    ref: modalRef,
    title: _ctx.$t('action.createNewRebateReport'),
    "is-loading": isLoading.value,
    submit: submitRebateReportRequest,
    style: {"width":"600px"}
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          "label-width": "70px",
          class: "demo-ruleForm",
          "status-icon": ""
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.name'),
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: formData.value.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.name) = $event)),
                  disabled: isLoading.value
                }, null, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.date'),
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_date_picker, {
                  class: "w-400px",
                  modelValue: period.value,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((period).value = $event)),
                  type: "datetimerange",
                  "start-placeholder": _ctx.$t('fields.startDate'),
                  "end-placeholder": _ctx.$t('fields.endDate'),
                  format: "YYYY-MM-DD HH:mm:ss",
                  "value-format": "YYYY-MM-DD HH:mm:ss",
                  disabled: isLoading.value
                }, null, 8, ["modelValue", "start-placeholder", "end-placeholder", "disabled"])
              ]),
              _: 1
            }, 8, ["label"]),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('fields.status'),
              required: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: stateId.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((stateId).value = $event)),
                  disabled: isLoading.value
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      label: _ctx.$t('fields.all'),
                      value: null
                    }, null, 8, ["label"]),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getTradeRebateStatusSelections), (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.value,
                        label: item.label,
                        value: item.value
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue", "disabled"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          _: 1
        })
      ])
    ]),
    _: 1
  }, 8, ["title", "is-loading"]))
}
}

})